import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_130_add_purchase_order: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Purchase order",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "pur_ord_add",
        TableName: "purchase_order",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Purchase order details",
            BindValue: "con_purchase_order_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_purchaseno",
                label: "Purchase order No.",
                placeholder: "Will be auto generated...",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "purchase_order_no",
                AutoPopulate: true,
                AutoPopulate_format: "PURORD_[******]",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_Purchase_date",
                label: "Purchase date",
                placeholder: "",
                required: true,
                DefaultToday: true,
                Json_Attribute: "purchase_order_date",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Purchase date is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_supplier",
                label: "Vendor",
                placeholder: "",
                required: true,
                lookupName: "supplier",
                options: [],
                Json_Attribute: "supplier_id",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Vendor is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_payment_term",
                label: "Payment term",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: false,
                Json_Attribute: "payment_term",
               
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_mobile",
                label: "Mobile",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: false,
                Json_Attribute: "mobile_no",
                BindParent: {
                  drp_supplier: "mobile_no",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_billingaddress",
                label: "Address",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "billing_address",
                BindParent: {
                  drp_supplier: "address",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_trn",
                label: "TRN",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "vendor_taxregno",
                BindParent: {
                  drp_supplier: "taxregno",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_remarks",
                label: "Remarks",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "remarks",
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "purchase_order_details",
            label: "Purchase details",
            tableName: "purchase_order_details",
            parentField: "drp_supplier",
            BindValue: "jobcard_details",
            childControls: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_product",
                label: "Code",
                placeholder: "",
                required: false,
                lookupName: "product_itemcode",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "product_id",
                BindValue: "drp_product",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_itemname",
                label: "Item name",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "item_name",
                disabled: true,
                BindValue: "txt_itemname",
                BindParent: {
                  drp_product: "item_name",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_rate",
                label: "Rate",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "rate",
                disabled: true,
                BindValue: "txt_rate",
                ExpressionV2: "[drp_product.purchase_rate]",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_qty",
                label: "Qty",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "qty",
                BindValue: "txt_qty",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount",
                label: "Amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "amount",
                disabled: true,
                BindValue: "txt_amount",
                ExpressionV2: "[txt_rate] * [txt_qty]",
              },
              {
                componentType: ComponentType.SELECT_DROPDOWN,
                name: "drp_vat",
                label: "VAT%",
                placeholder: "",
                required: false,
                lookupName: "tax_rates",
                options: [],
                defaultValue: "5%",
                Json_Attribute: "vat_id",
                BindValue: "drp_vat",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_vat_amt",
                label: "Vat amt",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "vat_amt",
                disabled: true,
                BindValue: "txt_vat_amt",
                ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_net_amt",
                label: "Net amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "net_amt",
                disabled: true,
                BindValue: "txt_net_amt",
                ExpressionV2: "[txt_amount] + [txt_vat_amt]",
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_one",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_2",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_3",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_4",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_amount",
                Json_Attribute: "amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "VAT amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "spare_vat_amount",
                Json_Attribute: "vat_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_net_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
